export default window.bootbox;
